import React from 'react';
import logo from '../assets/logo.png'; // Import the logo
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCaseStudiesClick = () => {
    if (location.pathname !== '/') {
      // Navigate to the home page, then scroll to the section
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('case-studies-section');
        if (element) {
          element.scrollIntoView({behavior: 'smooth' });
        }
      }, 100); // Wait briefly for navigation to complete
    } else {
      // Scroll directly if already on the home page
      const element = document.getElementById('case-studies-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleLogoClick = () => {
    navigate('/'); // Navigate to the home page
    setTimeout(() => {
      const headerElement = document.getElementById('header-section');
      if (headerElement) {
        headerElement.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0);
  };

  return (
    <header className="header">
      <div className="container">
        <img
          src={logo}
          alt="Logo"
          className="logo"
          onClick={handleLogoClick}
          style={{ cursor: 'pointer' }}
        />
        <div className="buttons">
          <div className="button-background">
            <Link to="/lead-form" className="get-started-link">
              Get Started
            </Link>
          </div>
          <button onClick={handleCaseStudiesClick} className="case-studies-btn">
            Case Studies
          </button>
          <Link to="/meet-the-team" className="case-studies-btn">Meet the Team</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;